<!-- Start Footer Section -->
<footer>
    <div class="container">
        <div class="row footer-widgets">
            <!-- Start Contact Widget -->
            <div class="col-md-3 col-sm-6 col-xs-12 float-r">
                <div class="footer-widget contact-widget">
                    <h4>
                        <img src="../../../assets/images/footer-logo2.png" class="img-responsive" alt="Footer Logo" />
                    </h4>
                    <p style="color:white">
                        {{'FooterSlogan' | translate}}
                    </p>
                </div>
            </div>
            <!-- End Contact Widget -->
            <!-- Start latest Work Posts Widget -->
            <div class="col-md-3 col-sm-6 col-xs-12 float-r">
                <div class="footer-widget flickr-widget">
                    <h4>
                        {{'WorkScope' | translate}}
                    </h4>
                    <ul class="flickr-list">
                        <li>
                            <a href="../../../assets/images/work/img-1.jpg" class="lightbox">
                                <img alt="" src="../../../assets/images/work/img-1.jpg">
                            </a>
                        </li>
                        <li>
                            <a href="../../../assets/images/work/img-2.jpg" class="lightbox">
                                <img alt="" src="../../../assets/images/work/img-2.jpg">
                            </a>
                        </li>
                        <li>
                            <a href="../../../assets/images/work/img-3.jpg" class="lightbox">
                                <img alt="" src="../../../assets/images/work/img-3.jpg">
                            </a>
                        </li>
                        <li>
                            <a href="../../../assets/images/work/img-4.jpg" class="lightbox">
                                <img alt="" src="../../../assets/images/work/img-4.jpg">
                            </a>
                        </li>
                        <li>
                            <a href="../../../assets/images/work/img-5.jpg" class="lightbox">
                                <img alt="" src="../../../assets/images/work/img-5.jpg">
                            </a>
                        </li>
                        <li>
                            <a href="../../../assets/images/work/img-6.jpg" class="lightbox">
                                <img alt="" src="../../../assets/images/work/img-6.jpg">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- End latest Work  Widget -->
            <!-- Start Address Widget -->
            <div class="col-md-3 col-sm-6 col-xs-12 float-r">
                <div class="footer-widget">
                    <h4>
                        {{'AldawalOffice' | translate}}
                    </h4>
                    <ul class="address">
                        <li>
                            <a href="https://aldawal.com/Location.html"><i class="fa fa-map-marker"></i>{{'address' | translate}}</a>
                        </li>
                        <li>
                            <a href="#"><i class="fa fa-phone"></i>+966-11-4501055</a>
                        </li>
                        <li>
                            <a href="mailto:admin@aldawal.com"><i class="fa fa-envelope"></i> admin@aldawal.com</a>
                        </li>
                        <li>
                            <a href="#"><i class="fa fa-fax"></i> {{'phone' | translate}}:+966-11-4501055 -{{'fax' | translate}} (108) </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- End Address Widget -->
            <!-- Start Text Widget -->
            <div class="col-md-3 col-sm-6 col-xs-12 float-r">
                <div class="footer-widget hours-widget">
                    <h4>
                        {{'BusinessHours' | translate}}
                    </h4>
                    <div class="contact-info">
                        <p>{{'Support' | translate}}</p>
                        <ul class="hours">
                            <li>{{'Days' | translate}} <span>{{'Time' | translate}}</span></li>

                            <li>{{'friday' | translate}} <span>{{'closed' | translate}}</span></li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- End Text Widget -->
        </div>
        <!-- .row -->
    </div>
</footer>
<!-- End Footer Section -->
<!-- Start Copyright -->
<div class="copyright-section" style="background-color:black">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <p>
                    {{'copyright' | translate}} &copy; {{'year' | translate}}
                    <a href="http://aldawal.com/">
                        {{'aldawal' | translate}}
                    </a>
                </p>
            </div>
        </div>
        <!-- .row -->
    </div>
</div>
<!-- End Copyright -->